export enum MediaEntity {
	Index = 'media_entity.index',
	Show = 'media_entity.show',
	Create = 'media_entity.create',
	Update = 'media_entity.update',
	Confirmation = 'media_entity.confirmation',
	Delete = 'media_entity.delete',
}
